module.exports = __webpack_public_path__ + "static/media/Antonio-Bold.ebec6645.ttf";